import { Type } from 'class-transformer';
import { IsDateString, IsNotEmpty, IsNumber, ValidateNested } from 'class-validator';

export class TermsOfUseDto {
  @IsDateString()
  @IsNotEmpty()
  acceptedAt!: string;

  @IsNumber()
  @IsNotEmpty()
  version!: number;
}

export class LegalAgreementDto {
  @ValidateNested()
  @Type(() => TermsOfUseDto)
  termsOfUse!: TermsOfUseDto;
}
